import { VFC } from "react";
import { DocumentReference } from "firebase/firestore";
import { Meet } from "../Meet";
import { MemberButton } from "./Buttons/MemberButton";
import { ExplainButton } from "./Buttons/ExplainButton";
import { useSelector } from "../../../../redux/store";
import { currentUserIsGameMasterSelector } from "../../../../redux/selectors/currentUserIsGameMasterSelector";
import { GameStatusSection } from "../ComponentsCollapse/GameStatusSection/GameStatusSection";
import { ResetButton } from "./Buttons/ResetButton";

export const SmallDeviceView: VFC<{
  gameRef: DocumentReference;
  roomId: string;
  setBrowserSupported: (value: boolean) => void;
}> = ({ gameRef, setBrowserSupported, roomId }) => {
  const game = useSelector((state) => state.game.game);
  const isGameMaster = useSelector(currentUserIsGameMasterSelector);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);

  return (
    <>
      <MemberButton />
      <ExplainButton />
      {gameRefUrl && isGameMaster && <ResetButton />}
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <GameStatusSection
          small={true}
          game={game}
          gameRef={gameRef}
          isGameMaster={isGameMaster}
        />
        <div style={{ flex: 1 }}>
          <Meet
            onChangeSupport={(supported) => {
              setBrowserSupported(supported);
            }}
            roomId={roomId}
          />
        </div>
      </div>
    </>
  );
};
